<template>
  <div class="news-page">
    <!-- 新闻中心页面横幅 -->
    <section class="news-hero">
      <div class="hero-overlay">
        <div class="hero-content">
          <h1 v-for="(item, index) in defaultInfos.news_title" :key="index">
            {{ item }}
          </h1>
          <p
            v-for="(item, index) in defaultInfos.news_title_subtitle"
            :key="index"
          >
            {{ item }}
          </p>
        </div>
      </div>
    </section>

    <!-- 新闻列表 -->
    <section class="news-list-section">
      <div class="container">
        <!-- 新闻列表组件 -->
        <NewsList :news-list="news" @view-detail="switchToInfo" />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import NewsList from "./components/NewsList.vue";
import { useNewsStore, type NewsType } from "@/stores/news";
import { useDefaultInfoStore } from "@/stores/defaultInfo";
const defaultInfoStore = useDefaultInfoStore();
const defaultInfos = computed(() => defaultInfoStore.getFormateInfo);

const router = useRouter();

// 新闻数据
const news = ref<NewsType[]>([]);

// 查看详情
const switchToInfo = (item: any) => {
  router.push({ name: "NewsInfo" });
  localStorage.setItem("newsInfoId", item.id);
};

const newsStore = useNewsStore();

// 页面加载时获取数据
onMounted(async () => {
  await newsStore.fetchNewsList();
  news.value = newsStore.getNewsList;
});
</script>

<style scoped>
.news-page {
  width: 100%;
}

/* 新闻中心页面横幅 */
.news-hero {
  height: 300px;
  background-image: url("/Environment/全院/0.png");
  background-size: cover;
  background-position: center;
  position: relative;
  margin-top: 80px;
}

.news-hero .hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(26, 95, 180, 0.8),
    rgba(26, 95, 180, 0.4)
  );
  display: flex;
  align-items: center;
  justify-content: center;
}

.news-hero .hero-content {
  text-align: center;
  color: white;
  max-width: 1200px;
  padding: 0 20px;
}

.news-hero h1 {
  font-size: 3rem;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.3;
}

.news-hero p {
  font-size: 24px;
  margin-bottom: 30px;
  color: #f9cc9d;
  line-height: 1.5;
}

/* 内容区域通用样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.section-header h2 {
  font-size: 2.5rem;
  color: #1a5fb4;
  margin-bottom: 15px;
}

.section-header p {
  font-size: 1.1rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

/* 新闻列表 */
.news-list-section {
  padding: 60px 0;
}

/* 平板端适配 */
@media (max-width: 1024px) {
  .news-hero {
    height: 250px;
  }

  .news-list-section {
    padding: 50px 0;
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .news-hero {
    height: 200px;
    margin-top: 60px;
  }

  .news-hero h1 {
    font-size: 2rem;
    margin-bottom: 15px;
  }

  .news-hero p {
    font-size: 18px;
    margin-bottom: 20px;
  }

  .news-list-section {
    padding: 40px 0;
  }

  .container {
    padding: 0 15px;
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  .news-hero {
    height: 180px;
  }

  .news-hero h1 {
    font-size: 1.6rem;
  }

  .news-hero p {
    font-size: 16px;
  }

  .news-list-section {
    padding: 30px 0;
  }

  .container {
    padding: 0 10px;
  }
}
</style>
